import React from 'react';

import { ICusWishlistResources } from '../../cus-wishlist.props.autogenerated';
import Button from '../../../../components/custom/button/button';
import { WishlistFallbackStateTemplate } from '../wishlist-fallback-state-template/wishlist-fallback-state-template';

interface Props {
    resources: ICusWishlistResources;
}

export const WishlistError = ({ resources }: Props) => (
    <WishlistFallbackStateTemplate heading={resources.wishlistErrorText} description={resources.wishlistErrorGettingWishlist}>
        <Button onClick={() => window.location.reload()}>{resources.reloadPageButtonText}</Button>
    </WishlistFallbackStateTemplate>
);
